import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { connect } from 'react-redux';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';
import { SbRespSortItems } from '../../finding/SbRespSortItems/SbRespSortItems';
import { BuyRespTopNavFilters } from './BuyRespTopNavFilters';
import { SbRespRefineTopAppliedFilters } from '../../finding/SbRespRefineTopNav/SbRespRefineTopAppliedFilters';
import { sortOrderLabel } from '../../shared/sharedMessages';

// styles
import styles from './buyRespTopNav.scss';

function BuyRespTopNavComponent({ viewer, buyPage: itemSearch, isClient, user = {} }) {
    return (
        <div className={styles.wrapper}>
            <CurrencyProvider
                render={({ currency }) => (
                    <>
                        <div className={styles.topSection}>
                            <BuyRespTopNavFilters
                                itemSearch={itemSearch}
                                viewer={viewer}
                                user={user}
                                currency={currency}
                                isClient={isClient}
                            />
                            <div className={styles.sortAndPriceContainer}>
                                <span className={styles.label}>{sortOrderLabel}</span>
                                <SbRespSortItems itemSearch={itemSearch} />
                            </div>
                        </div>
                        <div className={styles.middleSection}>
                            <div className={styles.appliedFiltersWrapper}>
                                <SbRespRefineTopAppliedFilters
                                    currency={currency}
                                    itemSearch={itemSearch}
                                    user={user}
                                />
                            </div>
                        </div>
                    </>
                )}
            />
        </div>
    );
}

BuyRespTopNavComponent.propTypes = {
    viewer: PropTypes.object,
    buyPage: PropTypes.object,
    isTrade: PropTypes.bool,
    isClient: PropTypes.bool,
    user: PropTypes.object,
};

const mapStateToProps = ({ relayVariables }) => {
    return {
        isClient: relayVariables.variables.isClient,
    };
};

export const BuyRespTopNav = createFragmentContainer(
    connect(mapStateToProps)(BuyRespTopNavComponent),
    {
        buyPage: graphql`
            fragment BuyRespTopNav_buyPage on ItemSearchQueryConnection {
                ...BuyRespTopNavFilters_itemSearch
                ...SbRespRefineTopAppliedFilters_itemSearch
                ...SbRespSortItems_itemSearch
                ...useMeasurementUnit_itemSearch
            }
        `,
        viewer: graphql`
            fragment BuyRespTopNav_viewer on Viewer {
                ...BuyRespTopNavFilters_viewer
            }
        `,

        user: graphql`
            fragment BuyRespTopNav_user on User {
                ...useMeasurementUnit_user
                ...BuyRespTopNavFilters_user
                ...SbRespRefineTopAppliedFilters_user
            }
        `,
    }
);
